import { render, staticRenderFns } from "./paymentTest.vue?vue&type=template&id=22d06acd&scoped=true&"
import script from "./paymentTest.vue?vue&type=script&lang=js&"
export * from "./paymentTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d06acd",
  null
  
)

export default component.exports